export default "__VITE_ASSET__DxuCr0Vj__"